import React from "react";
import "./Footer.css";
import { useState } from "react";

const FooterComponent = () => {
  const [phoneNo, setphoneNo] = useState("");
  const [password, setpassword] = useState("");
  const [otpRef, setotpRef] = useState("");
  const [message, setmessage] = useState("");

  return (
    <div class="footer-txt">
      Copyright &copy; 2022 All rights reserved. <br />
      Powered by Uvva Infotech Pvt. Ltd.
    </div>
  );
};

export default FooterComponent;
